import ErrorSubclass from 'util/ErrorSubclass';

export default class ColumnTypeValidationException extends ErrorSubclass {}
